import Entity from 'components/AddRemoveTableSortable/types/Entity'
import React, { RefObject, useEffect } from 'react'
import ModalEditableProps from '../types/ModalEditableProps'

interface useInitProps {
  row?: Entity
  relationalFieldName: string
  formComponent?: React.FunctionComponent<ModalEditableProps>
  setModalBody: Function
  submitRef: RefObject<any>
  setShowModal: Function
  setIsRequestLoading: Function
  triggerDataUpdate: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    props.setModalBody(null)
    if (props.row?.id !== undefined) {
      const formComponent = React.createElement<any>(
        props.formComponent as React.FunctionComponent,
        {
          modalConfig: {
            entityId: props.row?.[props.relationalFieldName],
            setIsRequestLoading: props.setIsRequestLoading,
            triggerDataUpdate: props.triggerDataUpdate,
          } as ModalEditableProps,
          //pass ref as an additional prop (use forwardRef in a child component)
          ref: props.submitRef,
        },
      )
      props.setModalBody(formComponent)
    }
    return () => {
      props.setModalBody(null)
    }
  }, [props.row])
}

export default useInit
